import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceAreas from "@/pages/ServiceAreas";
import RequestQuote from "@/pages/RequestQuote";
import ContractorPartner from "@/pages/ContractorPartner";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Pricing from "@/pages/Pricing";
import PayResult from "@/pages/PayResult";
import PayCancelled from "@/pages/PayCancelled";
import { PayDeposit, PayUnlock } from "@/pages/PayLandings";
import SuburbLanding from "@/pages/SuburbLanding";
import SkipBinLanding from "@/pages/SkipBinLanding";
import SkipBinsPage from "@/pages/SkipBinsPage";
import LandscapingPage from "@/pages/LandscapingPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/service-areas/:slug" element={<ServiceAreas />} />
          <Route path="/site-cleanup-craigieburn" element={<SuburbLanding />} />
          <Route path="/site-cleanup-epping" element={<SuburbLanding />} />
          <Route path="/site-cleanup-wollert" element={<SuburbLanding />} />
          <Route path="/skip-bins-craigieburn" element={<SkipBinLanding />} />
          <Route path="/skip-bins-epping" element={<SkipBinLanding />} />
          <Route path="/skip-bins" element={<SkipBinsPage />} />
          <Route path="/landscaping" element={<LandscapingPage />} />
          <Route path="/request-quote" element={<RequestQuote />} />
          <Route path="/partner" element={<ContractorPartner />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/pay/result" element={<PayResult />} />
          <Route path="/pay/cancelled" element={<PayCancelled />} />
          <Route path="/pay/deposit" element={<PayDeposit />} />
          <Route path="/pay/unlock" element={<PayUnlock />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
